<!-- Start Page Title Area -->
<section class="page-title-banner">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h2>Signup</h2>
      </div>
    </div>
  </div>

  <div class="shape1"><img src="assets/img/shape1.png" alt="img"></div>
  <div class="shape2"><img src="assets/img/shape2.png" alt="img"></div>
  <div class="shape3"><img src="assets/img/shape3.png" alt="img"></div>
  <div class="shape6"><img src="assets/img/shape6.png" alt="img"></div>
  <div class="shape8 rotateme"><img src="assets/img/shape8.svg" alt="shape"></div>
  <div class="shape9"><img src="assets/img/shape9.svg" alt="shape"></div>

</section>
<!-- End Page Title Area -->

<!-- Start Signup Area -->
<section class="signup-area ptb-50">
  <div class="container">
    <div class="row h-100 justify-content-center align-items-center">
      <!-- <div class="col-lg-4 col-md-12">
                <div class="signup-image">
                    <img src="assets/img/signup.png" alt="image">
                </div>
            </div> -->

      <div class="col-lg-10 col-md-12">
        <div class="signup-form">
          <div class="col-lg-6 back mb-3">
            <i class="icofont-arrow-left"></i> <a (click)="backToLogin()" class="pointer">Retourner à la page de
              connexion</a>
          </div>
          <h3>Compléter votre profil</h3>
          <form [formGroup]="form" (ngSubmit)="submit()">
            <!-- Participants -->
            <div class="col-lg-12 mb-4">
              <div class="card">
                <div class="card-header fw-bold">
                  Mode de participation & Participants
                </div>

                <div class="card-body">

                  <!-- MODE DE PARTICIPATION -->
                  <div class="form-group mb-3">
                    <label class="fw-semibold">Mode de participation</label><br>
                    <input type="radio" formControlName="participationMode" [value]="ParticipationMode.INDIVIDUAL">
                    Individuelle
                    &nbsp;&nbsp;
                    <input type="radio" formControlName="participationMode" [value]="ParticipationMode.GROUP"> Groupe
                  </div>

                  <!-- CHEF DE GROUPE -->
                  <div>
                    <div class="form-group mb-3">
                      <label class="fw-semibold" *ngIf="form.value.participationMode === ParticipationMode.GROUP">Chef
                        de
                        groupe</label>
                      <label class="fw-semibold"
                        *ngIf="form.value.participationMode === ParticipationMode.INDIVIDUAL">Participant</label>

                      <br>
                      <button type="button" class="btn btn-outline-primary btn-sm" (click)="openAddParticipant(true)"
                        [disabled]="!!(form.value.groupChief && form.value.groupChief.id)">
                        <span *ngIf="form.value.participationMode === ParticipationMode.INDIVIDUAL">Ajouter le
                          participant</span>
                        <span *ngIf="form.value.participationMode === ParticipationMode.GROUP">Ajouter le chef de
                          groupe</span>
                      </button>
                    </div>
                    <app-participants-list [participants]="!!form.value.groupChief ? [form.value.groupChief] : []"
                      (edit)="openEditParticipant($event, true)" (remove)="removeParticipant($event, true)">
                    </app-participants-list>

                    <!-- AUTRES MEMBRES -->
                    <div class="form-group mt-4 mb-3" *ngIf="form.value.participationMode === ParticipationMode.GROUP">
                      <label class="fw-semibold">Autres participants (max 3)</label><br>
                      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAddParticipant()"
                        [disabled]="form.value.groupParticipant.length >= 3">
                        Ajouter un participant
                      </button>
                    </div>

                    <app-participants-list [participants]="form.value.groupParticipant"
                      (edit)="openEditParticipant($event)" (remove)="removeParticipant($event)">
                    </app-participants-list>
                  </div>

                </div>
              </div>
            </div>

            <!-- Réseaux sociaux -->
            <div class="col-lg-12 mb-4">
              <div class="card">
                <div class="card-header fw-bold">
                  Réseaux sociaux
                </div>

                <div class="card-body">

                  <div class="form-check mb-3">
                    <input type="checkbox" class="form-check-input" formControlName="isSubscribedToDasp">
                    <label class="form-check-label">
                      Êtes-vous abonné(e) à une page officielle du DASP ?
                    </label>
                  </div>

                  <div class="form-group mb-3" *ngIf="form.get('isSubscribedToDasp').value">
                    <label class="fw-semibold">Plateformes</label><br>
                    <input type="checkbox" formControlName="hasFacebook" (change)="toggleSocialPlatform(SocialPlatform.FACEBOOK)">
                    Facebook (ex: https://www.facebook.com/nomprofil)
                    <div *ngIf="isfacebookSelected">
                      <div class="form-group mb-3">
                        <input type="text" class="form-control" placeholder="Nom du compte"
                          formControlName="facebookAccount">
                      </div>

                      <div class="form-group">
                        <input class="form-control" formControlName="facebookLink"
                          [class.is-invalid]="isInvalid('facebookLink')" placeholder="Lien du profil Facebook">

                        <div class="invalid-feedback">
                          <span *ngIf="form.get('facebookLink')?.errors?.['invalid']">
                            Le lien doit être un profil Facebook valide
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-3" *ngIf="form.get('isSubscribedToDasp').value">
                    <input type="checkbox" formControlName="hasInstagram" (change)="toggleSocialPlatform(SocialPlatform.INSTAGRAM)">
                    Instagram (ex: https://www.instagram.com/nomprofil)
                    <div *ngIf="isInstagramSelected">
                      <div class="form-group mb-3">
                        <input type="text" class="form-control" placeholder="Nom du compte"
                          formControlName="instagramAccount">
                      </div>

                      <div class="form-group">
                        <input class="form-control" formControlName="instagramLink"
                          [class.is-invalid]="isInvalid('instagramLink')" placeholder="Lien du profil Instagram">

                        <div class="invalid-feedback">
                          <span *ngIf="form.get('instagramLink')?.errors?.['invalid']">
                            Le lien doit être un profil Instagram valide
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Consentements -->
            <div class="col-lg-12 mb-4">
              <div class="card">
                <div class="card-header fw-bold">
                  Consentements & validations
                </div>

                <div class="card-body">

                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" formControlName="exactInformations">
                    <label class="form-check-label">
                      Je certifie l’exactitude des informations fournies
                    </label>
                  </div>

                  <div class="form-check mb-2">
                    <input type="checkbox" class="form-check-input" formControlName="hasAcceptedTerms">
                    <label class="form-check-label">
                      J’accepte les termes et conditions
                    </label>
                  </div>

                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="canUseContentForMarketing">
                    <label class="form-check-label">
                      Autoriser l’utilisation du contenu à des fins marketing
                    </label>
                  </div>

                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="confirmedRegistration">
                    <label class="form-check-label">
                      Je confirme mon inscription à la 2ᵉ édition du Design Atelier Students Prize (DASP)
                    </label>
                  </div>

                </div>
              </div>

              <div class="form-error alert alert-danger" *ngIf="submitted && invalidFields.length">
                <strong><i class="icofont-warning"></i> Veuillez corriger les erreurs suivantes :</strong>
                <ul class="mb-0 mt-2">
                  <li *ngFor="let field of invalidFields">
                    {{ getFieldLabel(field) }}
                  </li>
                </ul>
              </div>

              <!-- SUBMIT -->
              <div class="col-lg-12">
                <button type="submit" class="btn btn-primary">
                  {{isEditMode ? 'Enregistrer' : 'Soumettre l’inscription'}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Signup Area -->

<app-participant-modal *ngIf="showParticipantModal" [participant]="selectedParticipant" (save)="saveParticipant($event)"
  (close)="showParticipantModal = false" [isGroupChief]="isChiefAdding" [participationMode]="participationMode">
</app-participant-modal>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>